import { statAssets } from '../../constants/assets'

/**
 * The small outlined square holding the two-tone upward arrow. Each half of the arrow
 * is a separate export and is mirrored vertically in the design.
 */
export const TrendBadge = () => (
  <span className="flex h-[16px] w-[18px] shrink-0 items-center justify-center rounded-[6px] border border-solid border-dash-lime">
    <span className="relative block size-[16px] overflow-hidden">
      <span className="absolute bottom-[25.1%] left-1/2 right-0 top-[17.6%] block -scale-y-100">
        <img alt="" aria-hidden className="block size-full max-w-none" src={statAssets.trendArrowFront} />
      </span>
      <span className="absolute bottom-[17.72%] left-0 right-[50.1%] top-[32.22%] block -scale-y-100">
        <img alt="" aria-hidden className="block size-full max-w-none" src={statAssets.trendArrowBack} />
      </span>
    </span>
  </span>
)
